class MegaStockCounterElement extends HTMLElement {
  constructor() {
    super();    
    this.isInEditor=false;
    this.isInProductPage=true;
    this.guid = null;
    this.props = {stock_count: -9999999}    
    this.shadow = this.attachShadow({ mode: 'open' });    
    console.log("--=== Mega Stock Counter ===--") 
  }
  getProgressBar(){
    // <div class="{{ pb_classes }} count_{{ stock_count }} sold_{{ stock_sold }}">
    //   <span style="width: {{ pb_width }}%;"></span>
    // </div> 
    // this.props.progress_bar_max_width = 100;
    // this.props.progress_bar_color = '#FF0000';    
    let min_width = '50px';
    // let pb_classes='progress-bar pb-round pb-lines';
    let stock_count=+this.props.stock_count; // keep the plus!!!
    let stock_sold=40;
    let pb_width='75' // percentage;

    //====== Calculate pb_with ====
    /*if (stock_count == 0)
      stock_sold=100
    else if (stock_count==1)
      stock_sold=100
    else if (this.props.low_stock_condition>0 && stock_count<=this.props.low_stock_condition)
      stock_sold = stock_count + 50
    else if (this.props.high_stock_condition>0 && stock_count>=this.props.high_stock_condition)
      stock_sold=0
    else{
      stock_sold = stock_count * 4.0
      stock_sold = stock_count / 3.0
    }
  
    stock_sold = stock_sold / 1.0
    stock_count = stock_count / 1.0
    pb_width = stock_sold + stock_count
    pb_width = stock_count / pb_width
    pb_width = pb_width * 100.0*/    
  
  if (stock_count == 0)
      pb_width = 0
    else if (stock_count==1)
      pb_width=1
    else if (this.props.low_stock_condition>0 && stock_count<=this.props.low_stock_condition)
      pb_width = 25
    else if (this.props.high_stock_condition>0 && stock_count>=this.props.high_stock_condition)
      pb_width = 100
    else{
      pb_width = 75
    }    
    // console.log("STOCKSTOCK",this.props.low_stock_condition,stock_count);

  
    min_width = '15px'
    if (pb_width === 0)
      min_width = '0px'

    ////////  


    let pb_classes = `progress-bar ${this.props?.progress_bar_style?.includes('pill') ? 'pb-round' : ''} ${this.props?.progress_bar_style?.includes('animation') ? 'pb-lines' : ''}`;    
    return `
    <style>      
      .mpa_msc_wrapper .progress-bar {
        box-sizing: border-box;
        display: flex;
        text-align: left;
        height: 16px;
        width: 100%;
        max-width: ${ this.props.progress_bar_max_width }px;
        padding: 1px;
        margin: 0.3em 0.1em;
        background-color: #fff;
        border-width: 2px;
        border-style: solid;
        border-color: #${ this.props.progress_bar_color };
        border-radius: 2px;
      }
      .mpa_msc_wrapper .progress-bar span {
        display: inline-block;
        height: 100%;
        background-color: #${ this.props.progress_bar_color };
        transition: width 0.1s ease-in-out;
      }

      .mpa_msc_wrapper .pb-round {
        border-radius: 15px;
      }
      .mpa_msc_wrapper .pb-round span {
        min-width: ${ min_width };
        border-radius: 15px;
      }

      .mpa_msc_wrapper .pb-lines span {
        background-size: 2em 2em;
        background-image: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);

        animation: animate-lines 3s linear infinite;
      }

      @keyframes animate-lines {
        0% {
          background-position: 0 0;
        }
        100% {
          background-position: 60px 0;
        }
      }
    </style>

        
    <div class="${ pb_classes } count_${ stock_count } sold_${ stock_sold }">
      <span style="width: ${ pb_width }%;"></span>
    </div>    
    `;
  }
  getPulseDotCode(){
    return `
    <style>
      .mpa_msc_wrapper .ring-wrapper {
        display: inline-block;
        vertical-align: text-bottom;
        position: relative;
        /* top: 50%; */
        /* transform: translateY(-25%); */
        z-index: 50;
      }
      .mpa_msc_wrapper .ring-container {
        display: flex !important;
        position: relative;
        justify-content: center;
        align-items: center;
        width: ${ this.props.pulse_dot_size }px;
        height: ${ this.props.pulse_dot_size }px;
      }

      .mpa_msc_wrapper .circle {
        display: flex !important;
        width: 60%;
        height: 60%;
        background-color: #${ this.props.pulse_dot_color };
        border-radius: 50%;
        position: absolute;    
      }

      .mpa_msc_wrapper .ringring {
        display: flex !important;
        border: 3px solid #${ this.props.pulse_dot_color };
        -webkit-border-radius: 30px;
        height: 100%;
        width: 100%;
        position: absolute;
        -webkit-animation: pulsate 1s ease-out;
        -webkit-animation-iteration-count: infinite;
        opacity: 0.0
      }
      @-webkit-keyframes pulsate {
        0% {
          -webkit-transform: scale(0.1, 0.1);
          opacity: 0.0;
        }
        50% {
          opacity: 1.0;
        }
        100% {
          -webkit-transform: scale(1.2, 1.2);
          opacity: 0.0;
        }
      }
    </style>
    <span class="ring-wrapper">
      <div class="ring-container">
        <div class="ringring"></div>
        <div class="circle"></div>
      </div>
    </span>
    `;
  }    
  generateContent(){
    let element = this.shadow;
    let d=null;
    let additionalHtml = "";
    if(this.props.special_placement!=='none'){
      if(this.isInEditor){
        additionalHtml = `<div style="color: black;border: 1px red dashed;position: absolute;top: 0;background: lightgray;width: 100px;right: 0;font-size: 8px;">Will be placed in the chosen Special Placement on the live site.</div>`
      }
      else{
        element = document.querySelector(".mpa-msc-special-placement")
        if (!element){
          element = document.createElement("div");      
          element.classList.add('mpa-msc-special-placement');      
        }
        if(this.props.special_placement === "product_details")
          d = document.querySelector("[data-hook='details-placeholder']");      
        else
          d = document.querySelector("[data-hook='bottom-placeholder']");  
        if(d)    
          d.append(element);
      }
    }
    // console.log("GENERATE_CONTENT",this.props.stock_count)
    // console.log("is_app_locked",this.props.is_app_locked );
    if((this.isInEditor && this.props.stock_count_text) || this.props.stock_count>=0){
      element.innerHTML = `        
        <div class='mpa_msc_wrapper'>         
        ${additionalHtml}
          <div id='mpa_msc_stock_text' class=${this.isInProductPage}>        
           ${this.props.is_app_locked === 'true' ?
              //"App Locked. Click 👑 to Go Premium" :
              "Click 👑 to Start Your Free Trial!" :
              (this.props.pulse_dot_enabled === 'true' ? this.getPulseDotCode() : '') +
              (this.isInProductPage ? (this.isInEditor ? this.props.stock_count_text : this.props.stock_text) : "Mega Stock Counter is intended for product pages only")
            }
          </div>
          ${(this.props.progress_bar_style !== 'none') ? this.getProgressBar() : ''}   
        </div>
        <style>
          #mpa_msc_stock_text{
            color: #${this.props.text_color};
            font-family: '${this.props.font_family}';
            font-size: ${this.props.font_size}px;
            text-align: ${this.props.text_align};        
            ${(this.props.progress_bar_style !== 'none') ? 'padding-left: 2px;padding-right: 2px;' : ''}     
          }
          .mpa_stock_number{
            color: #${this.props.stock_number_color};
          }
          .mpa-msc-special-placement{
            padding-top: ${this.props.special_placement_padding_top}px !important;
            padding-bottom: ${this.props.special_placement_padding_bottom}px !important;
          }
        </style>
      `;      
    }
    else{
      // this.shadow.innerHTML = `<div class="mpa-msc-not-loaded">Loading... </div>`;
      // let d = document.querySelector("[data-hook='details-placeholder']");
      // let a = document.querySelector("mpa-msc").parentElement.parentElement.parentElement;
      // // this.shadow.querySelector('.mpa_msc_wrapper').style.marginTop = "17px";
      // console.log("wwwww3");
      // d.append(a);
    }
  }
  static get observedAttributes() {
    return ['guid','stock_count','stock_count_text','stock_text','text_color','stock_number_color','font_family','font_size','text_align','progress_bar_style','progress_bar_color','progress_bar_max_width','pulse_dot_enabled','pulse_dot_size','pulse_dot_color','special_placement','special_placement_padding_top','special_placement_padding_bottom','low_stock_condition','high_stock_condition','is_app_locked'];
  }

  connectedCallback() {     
    if(!window.wixDevelopersAnalytics){        
        this.isInEditor=true;     
        this.generateContent();
    }    
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // console.log('STOCK','attributeChangedCallback',this.guid,name,newValue);
    if(name === 'guid' && !this.guid){
      // console.log("STOCK","ATTR-CHANGE",this.guid);
      this.guid = newValue;
      if(window.wixDevelopersAnalytics){        
        window.wixDevelopersAnalytics.register(`b5753ce6-5ba5-4868-b790-2ed361bd78a9${this.guid}`, 
            (eventName, eventParams) => { 
              // console.log("StockEvent",eventName,eventParams);                     
              switch(eventName) { 
                  case 'PageView':                                            
                      this.isInProductPage=(eventParams?.pageTypeIdentifier === 'product_page');
                      if((eventParams?.pageTypeIdentifier !== 'product_page'))
                        this.dispatchEvent(new CustomEvent('nonProductPageLoaded', { detail: { data: `${eventParams?.pageTypeIdentifier}` } }));
                    break;
                  case 'productPageLoaded':                                    
                    this.dispatchEvent(new CustomEvent('productLoaded', { detail: { data: `${eventParams?.productId}` } }));                    
                    break; 
                  case 'CustomizeProduct':                                    
                    this.dispatchEvent(new CustomEvent('variantLoaded', { detail: { data: `${eventParams?.variantId}` } }));
                    break; 
                  case 'AddToCart':                
                    break;                    
                }
        });
      }
      else{
        //in editor?                
      }
    }
    setTimeout(()=>{
      this.props[name] = newValue;   
      // console.log("GENERATE_CONTENT-VALUE",name,newValue)
      this.generateContent();  
    },1)     
    }
//   }
}

// customElements.define('wix-default-custom-element', WixDefaultCustomElement);      
customElements.define('mpa-msc', MegaStockCounterElement);
// CustomElementRegistry.define('mpa-msc', MegaStockCounterElement);